import React, { useEffect, useState } from "react";
import { BaseDataTableSaveFooter } from "../../../components/ui/BaseDataTableFrame";

interface EditableRemarksSectionProps {
  title: string;
  subtitle: string;
  value?: string;
  onSave: (value: string) => Promise<void>;
}

const EditableRemarksSection: React.FC<EditableRemarksSectionProps> = ({
  title,
  subtitle,
  value,
  onSave,
}) => {
  const [draftValue, setDraftValue] = useState(value ?? "");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setDraftValue(value ?? "");
  }, [value]);

  const savedValue = value ?? "";
  const hasChanges = draftValue !== savedValue;

  const handleDiscard = () => {
    setDraftValue(value ?? "");
  };

  const handleSave = async () => {
    if (!hasChanges || isSaving) return;

    setIsSaving(true);

    try {
      const valueToSave = draftValue.trim().length === 0 ? "" : draftValue;
      await onSave(valueToSave);
      setDraftValue(valueToSave);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="flex w-full flex-col">
      <div className="mb-2 flex flex-col gap-2 font-[Inter]">
        <span className="text-[12px] font-medium leading-none text-[#0A0A0A]">
          {title}
        </span>

        <span className="text-[12px] font-normal leading-none text-[#737373]">
          {subtitle}
        </span>
      </div>

      <textarea
        disabled={isSaving}
        value={draftValue}
        onChange={(event) => setDraftValue(event.target.value)}
        placeholder="Enter details..."
        className="w-full min-h-[96px] max-h-[300px] h-auto [field-sizing:content] resize-y overflow-y-auto rounded-[8px] border border-[#E5E5E5] font-[Inter] bg-white px-3 py-2 text-[14px] font-normal leading-5 text-[#0A0A0A] shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] outline-none placeholder:text-[#737373] disabled:cursor-not-allowed disabled:bg-[#F9FAFB]"
      />

      {hasChanges && (
        <BaseDataTableSaveFooter
          isSaving={isSaving}
          disabled={false}
          onSave={handleSave}
          onDiscard={handleDiscard}
        />
      )}
    </div>
  );
};

export default EditableRemarksSection;
